import { Combobox } from './Combobox';

interface SuggestInputProps {
  id?: string;
  ariaLabel?: string;
  value: string;
  onChange: (value: string) => void;
  /** Die Vorschlaege zur aktuellen Eingabe -- der Aufrufer fragt sie ab. */
  suggestions: string[];
  loading?: boolean;
  /** Jede Eingabe, auch das Oeffnen -- Ausloeser fuer die Abfrage. */
  onSearch: (term: string) => void;
  /** Formt die Eingabe, bevor sie gilt -- etwa Grossbuchstaben beim Laendercode. */
  normalize?: (value: string) => string;
  placeholder?: string;
  disabled?: boolean;
}

/**
 * Ein Freitextfeld mit Vorschlaegen aus dem, was schon erfasst ist.
 *
 * **Es bleibt ein Freitextfeld.** Was getippt wird, gilt -- auch ohne Wahl
 * aus der Liste und ohne Eingabetaste. Die Vorschlaege sind ein Angebot: Wer
 * "gesund" tippt, sieht "Gesundheitswesen", das vierzigmal eingetragen ist,
 * und uebernimmt es mit einem Klick, statt eine dritte Schreibweise
 * einzufuehren. Genau daran leiden Auswertungen nach Branche sonst.
 *
 * Etappe 3 der Autovervollstaendigung (F1-49). Die Abfrage liegt beim
 * Aufrufer (``CrmSuggestInput``, ``CustomFieldSuggestInput``): Dieses Feld
 * kennt keinen Endpunkt.
 */
export function SuggestInput({
  id,
  ariaLabel,
  value,
  onChange,
  suggestions,
  loading = false,
  onSearch,
  normalize = (text) => text,
  placeholder,
  disabled,
}: SuggestInputProps) {
  return (
    <Combobox
      id={id}
      ariaLabel={ariaLabel}
      value={value ? { id: value, label: value } : null}
      options={suggestions
        .filter((entry) => entry !== value)
        .map((entry) => ({ id: entry, label: entry }))}
      onSearch={onSearch}
      onInput={(text) => {
        onChange(normalize(text));
      }}
      onChange={(option) => {
        onChange(option ? normalize(option.id || option.label) : '');
      }}
      loading={loading}
      placeholder={placeholder}
      disabled={disabled}
      allowFreeText
    />
  );
}
